import { createClient } from '@liveblocks/client';
import { decode } from 'base-64';
import { liveblocksPublicKey } from 'config';

export const client = createClient({
  publicApiKey: liveblocksPublicKey,
  unstable_fallbackToHTTP: true,
  polyfills: {
    atob: decode,
  },
}) as any;
